import ICompany from "../../models/ICompany";
import { SET_COMPANY, IContextAction, SET_AVAILABLE_COMPANIES } from "./types";

export function setCompany(company: ICompany | undefined): IContextAction {
  return {
    type: SET_COMPANY,
    payload: {
      company,
    },
  };
}

export function setAvailableCompanies(companies: Array<ICompany>): IContextAction {
  return {
    type: SET_AVAILABLE_COMPANIES,
    payload: {
      companies,
    },
  };
}
